import { render, staticRenderFns } from "./ViewActivities.vue?vue&type=template&id=1d3d5ceb&"
import script from "./ViewActivities.vue?vue&type=script&lang=js&"
export * from "./ViewActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports